export default "__VITE_ASSET__C4bs8nwE__"